var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ComponentContext } from '@employee-experience/common/lib/ComponentContext';
import { UsageHelper } from '@employee-experience/common/lib/Models/UsageTelemetry';
export function Shell(props) {
    var _a;
    const { children, appName } = props, context = __rest(props, ["children", "appName"]);
    const usageHelper = appName && appName.trim() != ''
        ? UsageHelper.Fork(appName)
        : UsageHelper;
    const telemetryContext = {
        sourceComponent: 'Shell',
        sourceScript: 'main',
        setUsageEvent: usageHelper.MassageEvent,
        setUsageUser: (usageUser) => {
            UsageHelper.SetUser(usageUser);
            usageHelper.SetUser(usageUser);
            return usageUser;
        },
        usageUser: usageHelper.GetUser,
        setUsageConfig: usageHelper.SetUsageConfig,
        getChildContext: usageHelper.ForkTelemetryContext,
    };
    (_a = context.telemetryClient) === null || _a === void 0 ? void 0 : _a.setContext(telemetryContext);
    return (React.createElement(ComponentContext.Provider, { value: Object.assign(Object.assign({}, context), { telemetryContext }) }, children));
}
//# sourceMappingURL=Shell.js.map